
import { t } from "i18next";
import { FC } from "react";

// Utilities
import { roundNumber } from "@/_helpers/number_functions";
import { capitalizeWords } from "@/_helpers/text_functions";

// Styles
import { Timer } from "@carbon/icons-react";

// Components
import { Box, Skeleton } from "@mui/material";
import Tag from "@/components/tag";


interface _DetailsProps {
    title: string;
    prepTime: number;
    cookTime: number;
    published?: boolean;
    isLoading?: boolean;
}

const Details: FC<_DetailsProps> = ({
    title,
    prepTime,
    cookTime,
    published = false,
    isLoading = false,
}) => {

    const totalTime = roundNumber(prepTime + cookTime, 0);

    return (
        <Box py={1} px={1} minHeight={32}>
            {/* Recipe Title */}
                {isLoading ? <Skeleton variant="rectangular" width="calc(100% - 16px)" height="18px" /> :
                    <div className="heading-08-compact-regular TwoLine--ellipsis" style={{display: '-webkit-box', height: '36px'}}>{capitalizeWords(title)}</div>}
                {/* Spacer */}
                <Box height={2} />
                {isLoading ? <Skeleton variant="rectangular" width="calc(100% - 8px)" height="32px" /> :
                    <Box 
                        className='label-text-02'
                        height={32}
                        sx={{
                            color: 'var(--icon-interactive)',
                            display: 'flex', gap: 0.5,
                            alignItems: 'center'
                        }}>
                        <Timer size={16} /> 
                        <span>{`${t('timeDate.min', {count: totalTime})}`}</span>
                        <Box flexGrow={1} />
                        <Tag colour={published ? 'cyan' : 'orange'} label={published ? t('general.published') : t('general.unpublished')} />
                    </Box>}
        </Box>
    );
}

export default Details;